import { DeclarationStatus } from '../enums';

export const DECLARATION_STATUSES_TO_KEEP = [
  DeclarationStatus.BEGATE_SENT,
  DeclarationStatus.BEGATE_NOT_RELEASED,
  DeclarationStatus.BEGATE_RELEASED,
  DeclarationStatus.ACCEPTED,
  DeclarationStatus.SENT,
  DeclarationStatus.RELEASED,
  DeclarationStatus.NOT_RELEASED,
  DeclarationStatus.INVALIDATED,
] as const;
